/**
 * Filter Controls Component
 * Matches AngularJS design patterns for top-right filter controls
 */

import React from 'react';

export interface FilterOption {
  value: string;
  label: string;
}

export interface FilterControlsProps {
  facilityOptions: FilterOption[];
  selectedFacility?: string;
  onFacilityChange: (value: string) => void;
  nameFilter?: string;
  onNameChange: (value: string) => void;
  className?: string;
}

const FilterControls: React.FC<FilterControlsProps> = ({
  facilityOptions,
  selectedFacility = '',
  onFacilityChange,
  nameFilter = '',
  onNameChange,
  className = ''
}) => {
  const handleFacilityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onFacilityChange(e.target.value);
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onNameChange(e.target.value);
  };

  return (
    <div className={`tec-filter-controls ${className}`}>
      <div className="tec-filter-group">
        <label htmlFor="facility-select">Facility:</label>
        <select
          id="facility-select"
          className="tec-form-control tec-form-select"
          value={selectedFacility}
          onChange={handleFacilityChange}
        >
          <option value="">All Facilities</option>
          {facilityOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="tec-filter-group">
        <label htmlFor="name-filter">Name:</label>
        <input
          id="name-filter"
          type="text"
          className="tec-form-control"
          placeholder="Search by name..."
          value={nameFilter}
          onChange={handleNameChange}
        />
      </div>
    </div>
  );
};

export default FilterControls;